import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
// import OverviewView from './components/OverviewView';
import InvoiceForm from './components/InvoiceForm';
import AdvancedFilterPanel, { FilterButton } from '../../components/common/AdvancedFilter';
import { getPeriodDateRange } from '../../components/common/AdvancedFilter/periodUtils';
import { usePersistedFilters } from '../../hooks/usePersistedFilters';
import FilterAwarenessBar from '../../components/common/AdvancedFilter/FilterAwarenessBar';
import { GenericView, SearchInput, ActionButtons } from '../../components/common/table';
import Alert from '../../components/Alert/Alert';
import ConfirmationModal from '../../components/common/ConfirmationModal';
import api from '../../api';
// Ganti import dummy data dengan API
import { getInvoices, getInvoiceStats, deleteInvoice, getInvoice } from './api/invoiceApi';
import { validateInvoiceForm } from '../../utils/validation';
import * as XLSX from 'xlsx';
import { useAuth } from '../../contexts/AuthProvider';
import { FileText } from 'lucide-react';
// enhancement invoiceTo, invoiceIssued
const Invoice = () => {
  const navigate = useNavigate();
  const { loadPersistedState, persistState } = usePersistedFilters('invoice');

  const [searchQuery, setSearchQuery] = useState('');

  // State to track if URL filters have been applied
  const [urlFiltersApplied, setUrlFiltersApplied] = useState(false);

  // Parse URL parameters and apply filters on mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const billDateFrom = urlParams.get('billDateFrom') || '';
    const billDateTo = urlParams.get('billDateTo') || '';
    // Get all status parameters (multiple status support)
    const statusParams = urlParams.getAll('status');
    const status = statusParams.length > 0 ? statusParams : '';
    const assignedTo = urlParams.get('assignedTo') || '';
    const createdById = urlParams.get('createdById') || '';
    const serviceId = urlParams.get('serviceId') || '';
    const departmentId = urlParams.get('departmentId') || '';
    const companyId = urlParams.get('company_id') || urlParams.get('companyId') || urlParams.get('client') || '';
    const updatedById = urlParams.get('uuser_id') || urlParams.get('updatedById') || '';
    const invoiceTo = urlParams.get('invoiceTo') || '';
    const invoiceIssued = urlParams.get('invoiceIssued') || '';
    const searchParam = urlParams.get('search') || '';

    // Update filterData if any URL parameters are present
    if (billDateFrom || billDateTo || status.length > 0 || assignedTo || createdById || serviceId || departmentId || companyId || updatedById || invoiceTo || invoiceIssued) {
      const urlFilters = (prev) => ({
        ...prev,
        billDateFrom,
        billDateTo,
        status,
        assignedUser: assignedTo,
        createdBy: createdById,
        service: serviceId,
        department: departmentId,
        company: companyId,
        updatedBy: updatedById,
        invoiceTo: invoiceTo,
        invoiceIssued: invoiceIssued
      });
      setFilterData(urlFilters);
      setAppliedFilterData(urlFilters);
    }

    // Update search query if present
    if (searchParam) {
      setSearchQuery(searchParam);
    }

    // Mark URL filters as applied
    setUrlFiltersApplied(true);
  }, []); // Empty dependency array - only run once on mount

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [formData, setFormData] = useState({
    client: '',
    projectName: '',
    projectId: null,    // ✅ Tambah projectId untuk edit mode
    leadId: null,       // ✅ Tambah leadId untuk fallback
    billDate: new Date().toISOString().split('T')[0],
    dueDate: '',
    description: '',
    jurnalNumber: '', // ✅ JURNAL NUMBER: Journal number field
    invoiceTo: '',
    invoiceIssued: '',
    tax: 0,
    applyTax: false,
    documents: [],
    status: 'Draft',
    items: [
      {
        description: '',
        quantity: 1,
        unitPrice: 0,
        tax: 0,
        total: 0
      }
    ],
    subtotal: 0,
    total: 0,
    notes: '',
    terms: '',
    paymentMethod: '',
    bankAccount: ''
  });
  const [formErrors, setFormErrors] = useState({});
  const emptyFilter = {
    period: '',
    dateFrom: '',
    dateTo: '',
    billDateFrom: '',
    billDateTo: '',
    dueDateFrom: '',
    dueDateTo: '',
    company: '',
    updatedBy: '',
    invoiceTo: '',
    invoiceIssued: '',
    status: '',
    assignedUser: '',
    createdBy: '',
    service: '',
    department: ''
  };
  // filterData = live editing state inside the offcanvas panel (not yet applied)
  const [filterData, setFilterData] = useState({ ...emptyFilter });
  // appliedFilterData = committed state used by fetchInvoices / totals / export
  const [appliedFilterData, setAppliedFilterData] = useState({ ...emptyFilter });

  // Tambahkan state untuk API data
  const [invoices, setInvoices] = useState([]);
  const [stats, setStats] = useState({
    total: { count: 0, amount: 'Rp 0' },
    paid: { count: 0, amount: 'Rp 0' },
    unpaid: { count: 0, amount: 'Rp 0' },
    overdue: { count: 0, amount: 'Rp 0' }
  });
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1, // 1-based for GenericView/TablePagination
    totalPages: 0,
    totalElements: 0,
    totalRows: 0,
    rowsPerPage: 10
  });
  const [alert, setAlert] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [showFinalizeModal, setShowFinalizeModal] = useState(false);
  const [itemToFinalize, setItemToFinalize] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfTitle, setPdfTitle] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [totalSums, setTotalSums] = useState({
    subtotal: 0,
    ppn: 0,
    totalInvoiced: 0,
    paymentReceived: 0,
    balance: 0
  });

  // Use global auth context with capabilities
  const { user, can, capabilitiesLoading } = useAuth();

  // Helper function to check invoice-specific capabilities
  const canInvoice = (capabilityKey) => can(capabilityKey, 'invoice');

  // State for filter options
  const [filterOptions, setFilterOptions] = useState({
    assignedUsers: [],    // Assigned users dari projects dengan invoices
    createdByUsers: [],   // Created by users dari invoices.cuser
    updatedByUsers: [],   // Updated by users untuk filter invoice
    services: [],
    departments: [],
    clients: [],
    projects: [],
    statuses: [
      { value: 'DRAFT', label: 'Draft' },
      { value: 'SENT', label: 'Sent' },
      { value: 'FINAL', label: 'Final' },
      { value: 'PAID', label: 'Paid' },
      { value: 'PARTIAL', label: 'Partial' },
    ]
  });

  // ✅ MULTI-CURRENCY: Add currency state and helper functions
  const [invoiceCurrencyCode, setInvoiceCurrencyCode] = useState('IDR');

  // ✅ MULTI-CURRENCY: Helper function untuk mendapatkan currency symbol
  const getCurrencySymbol = (currencyCode) => {
    switch (currencyCode) {
      case 'USD': return '$';
      case 'EUR': return '€';
      case 'JPY': return '¥';
      case 'GBP': return '£';
      case 'SGD': return 'S$';
      case 'AUD': return 'A$';
      case 'IDR': return 'Rp';
      default: return 'Rp';
    }
  };

  // ✅ MULTI-CURRENCY: Helper function untuk mendapatkan currency prefix
  const getCurrencyPrefix = (currencyCode) => {
    const prefix = getCurrencySymbol(currencyCode) + ' ';
    return prefix;
  };

  // Invoice headers are stored in the invoice/proposal currency. The list is
  // the IDR reporting view, so convert foreign-currency values exactly once.
  const toIdrAmount = (amount, item) => {
    const value = Number(amount) || 0;
    const code = (item?.displayCurrencyCode || item?.currencyCode || 'IDR').toUpperCase();
    if (code === 'IDR') return value;
    const rate = Number(item?.exchangeRateAtCreation) || 1;
    return value * rate;
  };



  // Fetch data on component mount (wait for capabilities to load and URL filters to be applied)
  useEffect(() => {
    if (!capabilitiesLoading && urlFiltersApplied) {
      const initializeData = async () => {
        try {
          // Only restore persisted state when there are no URL params (URL params take priority)
          const hasUrlParams = window.location.search.length > 1;
          if (!hasUrlParams) {
            const saved = loadPersistedState();
            if (saved) {
              const restoredFilters = saved.filters ?? { ...emptyFilter };
              const restoredSearch = saved.search ?? '';
              const restoredPage = saved.page ?? 0;
              const restoredSize = saved.size ?? 10;

              setFilterData(restoredFilters);
              setAppliedFilterData(restoredFilters);
              setSearchQuery(restoredSearch);
              setPagination(prev => ({ ...prev, currentPage: restoredPage + 1, rowsPerPage: restoredSize }));

              await Promise.allSettled([
                fetchInvoices({ page: restoredPage + 1, size: restoredSize }, false, restoredFilters, restoredSearch),
                fetchStats(),
                fetchTotals(),
                fetchFilterOptions()
              ]);
              return;
            }
          }
          await Promise.allSettled([
            fetchInvoices(),
            fetchStats(),
            fetchTotals(),
            fetchFilterOptions()
          ]);
        } catch (error) {
          console.error('Error during initialization:', error);
        }
      };

      initializeData();
    }
  }, [capabilitiesLoading, urlFiltersApplied]);

  // ✅ SEARCH: Handle search on Enter key press
  const handleSearch = () => {
    persistState({ filters: appliedFilterData, search: searchQuery, page: 0, size: pagination.rowsPerPage });
    setPagination(prev => ({ ...prev, currentPage: 1 }));
    fetchInvoices({ page: 1 });
    fetchTotals();
  };

  // ✅ SEARCH: Handle Enter key press in search input
  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch();
    }
  };

  // ✅ SEARCH: Handle search input change with auto-clear functionality
  const handleSearchChange = (value) => {
    setSearchQuery(value);

    // If search is cleared (empty), immediately fetch all data
    if (value === '' || value.trim() === '') {
      fetchInvoices();
    }
  };

  // Fetch filter options
  const fetchFilterOptions = async () => {
    try {
      // Fetch assigned users - filter based on permissions
      let assignedUsers = [];
      let createdByUsers = [];
      let updatedByUsers = [];
      try {
        const usersRes = await api.get('/md/internal-users/option-internal-user');
        let usersData = usersRes.data || [];
        
        // ✅ Permission-based filtering for assigned users:
        // 1. view_own → only show current user
        // 2. view_department → only show users in same department
        // 3. view_global → show all users
        if (!canInvoice('view_global')) {
          if (canInvoice('view_own')) {
            // Only show current user
            if (user?.id) {
              const userId = String(user.id);
              usersData = usersData.filter(u => String(u.id) === userId);
            }
          } else if (canInvoice('view_department')) {
            // Only show users in same department
            if (user?.departmentId) {
              const userDeptId = String(user.departmentId);
              usersData = usersData.filter(u => {
                // Handle both departmentId and departementId field names, and type conversion
                const uDeptId = u.departmentId || u.departementId;
                return uDeptId != null && String(uDeptId) === userDeptId;
              });
            } else {
              // If user has no departmentId, show empty array
              usersData = [];
            }
          }
        }
        
        assignedUsers = usersData.map(u => ({
          value: u.fullName || `${u.firstName} ${u.lastName}`.trim(),
          label: u.fullName || `${u.firstName} ${u.lastName}`.trim(),
          departmentId: u.departmentId || u.departementId,
          status: u.status
        }));

        createdByUsers = usersData.map(u => ({
          value: u.id,
          label: u.fullName || `${u.firstName} ${u.lastName}`.trim(),
          departmentId: u.departmentId || u.departementId,
          status: u.status
        }));

        updatedByUsers = usersData.map(u => ({
          value: u.id,
          label: u.fullName || `${u.firstName} ${u.lastName}`.trim(),
          departmentId: u.departmentId || u.departementId,
          status: u.status
        }));
      } catch (err) {
        console.error('Error fetching assigned users:', err);
        assignedUsers = [];
        createdByUsers = [];
        updatedByUsers = [];
      }

      // Fetch services - fetch all services from API
      let services = [];
      try {
        const servicesRes = await api.get('/crm/services/options');
        const servicesData = servicesRes.data || [];
        services = servicesData.map(service => ({
          value: service.value || service.id,
          label: service.label || service.name
        }));
      } catch (err) {
        console.error('Error fetching services:', err);
        services = [];
      }

      // Fetch departments - filter based on permissions
      let departments = [];
      try {
        const deptRes = await api.get('/md/departement');
        let deptData = deptRes.data || [];
        if (!canInvoice('view_global')) {
          if (user?.departmentId) {
            const userDeptId = String(user.departmentId);
            deptData = deptData.filter(dept => String(dept.id || '') === userDeptId);
          } else {
            deptData = [];
          }
        }
        departments = deptData.map(dept => ({
          value: dept.id,
          label: dept.name
        }));
      } catch (err) {
        console.error('Error fetching departments:', err);
        departments = [];
      }

      // Fetch clients - fetch all companies from API
      let clients = [];
      try {
        const clientsRes = await api.get('/crm/companies/options');
        const clientsData = clientsRes.data || [];
        clients = clientsData.map(company => ({
          value: company.value || company.id,
          label: company.label || company.name || company.companyName
        }));
      } catch (err) {
        console.error('Error fetching clients:', err);
        clients = [];
      }

      // Fetch projects - fetch all projects from API (with pagination to get all)
      let projects = [];
      try {
        const projectsRes = await api.get('/crm/projects', {
          params: {
            page: 0,
            size: 10000 // Large size to get all projects
          }
        });
        const projectsData = projectsRes.data?.content || projectsRes.data || [];
        projects = projectsData.map(project => ({
          value: project.id,
          label: project.projectName || project.name || project.label
        }));
      } catch (projectErr) {
        console.error('Error fetching projects:', projectErr);
        projects = [];
      }

      setFilterOptions(prev => ({
        ...prev,
        assignedUsers,    // All assigned users from API
        createdByUsers,   // All users from API (for created by filter)
        updatedByUsers,   // All users from API (for updated by filter)
        services,         // All services from API
        departments,      // All departments from API
        clients,          // All companies from API
        projects          // All projects from API
      }));
    } catch (error) {
      console.error('Error fetching filter options:', error);
      console.error('Filter options error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });

      // Don't show alert for filter options error as it's not critical
      // Just set empty arrays to prevent crashes
      setFilterOptions(prev => ({
        ...prev,
        assignedUsers: [],
        createdByUsers: [],
        services: [],
        departments: [],
        clients: [],
        projects: []
      }));
    }
  };

  // ✅ PAYMENT RECEIVED: Helper function to calculate paymentReceived from payments table
  const calculatePaymentReceived = async (invoiceId) => {
    try {
      const invoiceIdStr = String(invoiceId).trim();
      
      // Try to use a direct endpoint if available, otherwise fetch and filter
      // Since the payments endpoint doesn't support invoiceId filter, we need to fetch all and filter
      // This is a workaround - ideally the backend should support invoiceId parameter
      try {
        // Try to fetch payments using the repository method through a potential endpoint
        // If that doesn't work, we'll fetch all payments and filter (inefficient but works)
        const paymentsResponse = await api.get('/crm/payments', {
          params: {
            page: 0,
            size: 10000 // Large size to get all payments (inefficient but necessary)
          }
        });
        
        const allPayments = paymentsResponse.data?.content || paymentsResponse.data || [];
        
        // Filter payments by invoiceId
        const invoicePayments = allPayments.filter(payment => {
          const paymentInvoiceId = String(payment.invoiceId || '').trim();
          return paymentInvoiceId === invoiceIdStr;
        });
        
        // Calculate total from filtered payments
        const total = invoicePayments.reduce((sum, payment) => {
          const amount = parseFloat(payment.amount) || 0;
          return sum + amount;
        }, 0);
        
        return total;
      } catch (fetchError) {
        console.warn(`Failed to fetch payments for invoice ${invoiceId}:`, fetchError);
        return 0;
      }
    } catch (error) {
      console.warn(`Error calculating payment received for invoice ${invoiceId}:`, error);
      return 0; // Return 0 if calculation fails
    }
  };

  // ✅ EXPORT: Helper function to build query params for export (without pagination)
  const buildExportQueryParams = () => {
    const queryParams = {
      page: 0,
      size: 10000 // Large size to get all invoices
    };

    // Add filter params
    if (appliedFilterData.dateFrom) queryParams.startDate = appliedFilterData.dateFrom;
    if (appliedFilterData.dateTo) queryParams.endDate = appliedFilterData.dateTo;
    if (appliedFilterData.billDateFrom) queryParams.billDateFrom = appliedFilterData.billDateFrom;
    if (appliedFilterData.billDateTo) queryParams.billDateTo = appliedFilterData.billDateTo;
    if (appliedFilterData.dueDateFrom) queryParams.dueDateFrom = appliedFilterData.dueDateFrom;
    if (appliedFilterData.dueDateTo) queryParams.dueDateTo = appliedFilterData.dueDateTo;
    if (appliedFilterData.company) queryParams.company_id = appliedFilterData.company;
    if (appliedFilterData.updatedBy) queryParams.uuser_id = appliedFilterData.updatedBy;
    if (appliedFilterData.invoiceTo) queryParams.invoiceTo = appliedFilterData.invoiceTo;
    if (appliedFilterData.invoiceIssued) queryParams.invoiceIssued = appliedFilterData.invoiceIssued;
    if (appliedFilterData.status && Array.isArray(appliedFilterData.status)) {
      queryParams.status = appliedFilterData.status;
    } else if (appliedFilterData.status) {
      queryParams.status = appliedFilterData.status;
    }
    if (appliedFilterData.assignedUser) {
      queryParams.assignedTo = appliedFilterData.assignedUser;
    }
    if (appliedFilterData.createdBy) queryParams.createdById = appliedFilterData.createdBy;
    if (appliedFilterData.service) queryParams.serviceId = appliedFilterData.service;
    if (appliedFilterData.department) queryParams.departmentId = appliedFilterData.department;

    // Add search query parameter
    if (searchQuery && searchQuery.trim() !== '') {
      queryParams.search = searchQuery.trim();
    }

    // Permission-based filtering
    if (!canInvoice('view_global')) {
      if (canInvoice('view_department')) {
        if (user?.departmentId) {
          queryParams.viewDepartmentId = user.departmentId;
        }
      } else if (canInvoice('view_own')) {
        if (user?.id) {
          queryParams.viewOwnUserId = user.id;
        }
      }
    }

    return queryParams;
  };

  // ✅ EXPORT: Helper function to check if any filters are active
  const hasActiveFilters = () => {
    return !!(
      appliedFilterData.dateFrom ||
      appliedFilterData.dateTo ||
      appliedFilterData.billDateFrom ||
      appliedFilterData.billDateTo ||
      appliedFilterData.dueDateFrom ||
      appliedFilterData.dueDateTo ||
      appliedFilterData.company ||
      appliedFilterData.updatedBy ||
      appliedFilterData.invoiceTo ||
      appliedFilterData.invoiceIssued ||
      appliedFilterData.status ||
      appliedFilterData.assignedUser ||
      appliedFilterData.createdBy ||
      appliedFilterData.service ||
      appliedFilterData.department ||
      (searchQuery && searchQuery.trim() !== '')
    );
  };

  function formatInvoiceIssuedLabel(value) {
    if (!value) return '';
    if (value === 'before') return 'Before';
    if (value === 'after') return 'After';
    return value;
  }

  const invoiceFilterTags = useMemo(() => {
    const tags = [];
    const addIfValue = (key, label, value) => {
      if (!value) return;
      tags.push({ key, label: `${label}: ${value}` });
    };

    if (appliedFilterData.dateFrom || appliedFilterData.dateTo) {
      tags.push({ key: 'dateRange', label: `Created Date: ${[appliedFilterData.dateFrom, appliedFilterData.dateTo].filter(Boolean).join(' - ')}` });
    }
    if (appliedFilterData.billDateFrom || appliedFilterData.billDateTo) {
      tags.push({ key: 'billDate', label: `Bill Date: ${[appliedFilterData.billDateFrom, appliedFilterData.billDateTo].filter(Boolean).join(' - ')}` });
    }
    if (appliedFilterData.dueDateFrom || appliedFilterData.dueDateTo) {
      tags.push({ key: 'dueDate', label: `Due Date: ${[appliedFilterData.dueDateFrom, appliedFilterData.dueDateTo].filter(Boolean).join(' - ')}` });
    }

    addIfValue('company', 'Company', appliedFilterData.company);
    addIfValue('updatedBy', 'Updated By', appliedFilterData.updatedBy);
    addIfValue('invoiceTo', 'Invoice To', appliedFilterData.invoiceTo);
    addIfValue('invoiceIssued', 'Term of Payments', formatInvoiceIssuedLabel(appliedFilterData.invoiceIssued));
    addIfValue('assignedUser', 'Assigned To', appliedFilterData.assignedUser);
    addIfValue('createdBy', 'Created By', appliedFilterData.createdBy);
    addIfValue('service', 'Service', appliedFilterData.service);
    addIfValue('department', 'Department', appliedFilterData.department);

    if (Array.isArray(appliedFilterData.status) && appliedFilterData.status.length > 0) {
      tags.push({ key: 'status', label: `Status: ${appliedFilterData.status.length} selected` });
    } else if (appliedFilterData.status) {
      tags.push({ key: 'status', label: `Status: ${appliedFilterData.status}` });
    }

    if (searchQuery && searchQuery.trim() !== '') {
      tags.push({ key: 'search', label: `Search: ${searchQuery.trim()}` });
    }

    return tags;
  }, [appliedFilterData, searchQuery]);

  const invoiceActiveFilterCount = invoiceFilterTags.length;

  const handleInvoiceFilterTagRemove = (key) => {
    if (key === 'search') {
      setSearchQuery('');
      setPagination(prev => ({ ...prev, currentPage: 1 }));
      persistState({ filters: appliedFilterData, search: '', page: 0, size: pagination.rowsPerPage });
      fetchInvoices({ page: 1 }, false, filterData, '');
      fetchTotals();
      return;
    }

    const nextFilters = { ...appliedFilterData };
    if (key === 'dateRange') {
      nextFilters.dateFrom = '';
      nextFilters.dateTo = '';
    } else if (key === 'billDate') {
      nextFilters.billDateFrom = '';
      nextFilters.billDateTo = '';
    } else if (key === 'dueDate') {
      nextFilters.dueDateFrom = '';
      nextFilters.dueDateTo = '';
    } else if (key === 'status') {
      nextFilters.status = '';
    } else {
      nextFilters[key] = '';
    }

    setFilterData(nextFilters);
    setAppliedFilterData(nextFilters);
    setPagination(prev => ({ ...prev, currentPage: 1 }));
    persistState({ filters: nextFilters, search: searchQuery, page: 0, size: pagination.rowsPerPage });
    fetchInvoices({ page: 1 }, false, nextFilters);
    setTimeout(() => fetchTotals(), 0);
  };

  // ✅ TOTALS: Fetch aggregate sums from backend (single efficient query, no 10k-record fetch)
  const fetchTotals = async () => {
    try {
      const queryParams = buildExportQueryParams();
      // Remove pagination params — aggregate endpoint doesn't need them
      const { page, size, sortBy, sortDir, ...aggregateParams } = queryParams;
      const response = await api.get('/crm/invoices/aggregate', { params: aggregateParams });
      const data = response.data || {};
      setTotalSums({
        subtotal: parseFloat(data.subTotal ?? data.subtotal ?? 0),
        ppn: parseFloat(data.ppn ?? 0),
        totalInvoiced: parseFloat(data.totalInvoiced ?? 0),
        paymentReceived: parseFloat(data.paymentReceived ?? 0),
        balance: 0
      });
    } catch (error) {
      console.error('Error fetching invoice totals:', error);
      setTotalSums({ subtotal: 0, ppn: 0, totalInvoiced: 0, paymentReceived: 0, balance: 0 });
    }
  };

  // Fetch invoices with filters
  const fetchInvoices = async (params = {}, skipFilter = false, filterOverride = null, searchOverride = null) => {
    setLoading(true);
    try {
      const effectiveFilters = filterOverride || appliedFilterData;
      const effectiveSearch = searchOverride !== null ? searchOverride : searchQuery;
      // Normalize 1-based UI to 0-based API, and PREVENT override by params spread
      const requestedPage = params.page ?? pagination.currentPage; // 1-based
      const requestedSize = params.size ?? pagination.rowsPerPage;
      const queryParams = {
        page: Math.max(0, (requestedPage || 1) - 1),
        size: requestedSize,
      };

      // Add filter params (skip if skipFilter is true)
      if (!skipFilter) {
        if (effectiveFilters.dateFrom) queryParams.startDate = effectiveFilters.dateFrom;
        if (effectiveFilters.dateTo) queryParams.endDate = effectiveFilters.dateTo;
        if (effectiveFilters.billDateFrom) queryParams.billDateFrom = effectiveFilters.billDateFrom;
        if (effectiveFilters.billDateTo) queryParams.billDateTo = effectiveFilters.billDateTo;
        if (effectiveFilters.dueDateFrom) queryParams.dueDateFrom = effectiveFilters.dueDateFrom;
        if (effectiveFilters.dueDateTo) queryParams.dueDateTo = effectiveFilters.dueDateTo;
        if (effectiveFilters.company) queryParams.company_id = effectiveFilters.company;
        if (effectiveFilters.updatedBy) queryParams.uuser_id = effectiveFilters.updatedBy;
        if (effectiveFilters.invoiceTo) queryParams.invoiceTo = effectiveFilters.invoiceTo;
        if (effectiveFilters.invoiceIssued) queryParams.invoiceIssued = effectiveFilters.invoiceIssued;
        if (effectiveFilters.status && Array.isArray(effectiveFilters.status)) {
      // Handle multiple status values - pass as array to API
      queryParams.status = effectiveFilters.status;
    } else if (effectiveFilters.status) {
      queryParams.status = effectiveFilters.status;
    }
        if (effectiveFilters.assignedUser) {
          queryParams.assignedTo = effectiveFilters.assignedUser;
        }
        if (effectiveFilters.createdBy) queryParams.createdById = effectiveFilters.createdBy;
        if (effectiveFilters.service) queryParams.serviceId = effectiveFilters.service;
        if (effectiveFilters.department) queryParams.departmentId = effectiveFilters.department;
      }

      // ✅ SEARCH: Add search query parameter
      if (effectiveSearch && effectiveSearch.trim() !== '') {
        queryParams.search = effectiveSearch.trim();
      }

      // ✅ Permission-based filtering hierarchy:
      // 1. view_global → see all (no filter)
      // 2. view_department → filter by user's department
      // 3. view_own → filter by user ID (created by OR assigned to)

      if (!canInvoice('view_global')) {
        if (canInvoice('view_department')) {
          // Filter by department
          if (user?.departmentId) {
            queryParams.viewDepartmentId = user.departmentId;
          }
        } else if (canInvoice('view_own')) {
          // Filter by user
          if (user?.id) {
            queryParams.viewOwnUserId = user.id;
          }
        }
      }

      // ✅ SORTING: Add sorting parameters if sortConfig is set
      if (params.sortBy || sortConfig.key) {
        const sortBy = params.sortBy || sortConfig.key;
        const sortDir = params.sortDir || sortConfig.direction;
        
        // Map frontend column keys to backend field names
        const fieldMapping = {
          'invoiceNumber': 'invoiceNumber',
          'departmentName': 'departmentName',
          'client': 'client',
          'description': 'description',
          'projectName': 'projectName',
          'proposalCode': 'proposalCode',
          'subtotal': 'subtotal',
          'ppn': 'ppn',
          'totalInvoiced': 'totalInvoiced',
          'paymentReceived': 'paymentReceived',
          'due': 'due',
          'billDate': 'billDate',
          'dueDate': 'dueDate',
          'assignedUserName': 'assignedUserName',
          'createdByName': 'createdByName',
          'updatedByName': 'updatedByName',
          'serviceName': 'serviceName',
          'balance': 'balance',
          'status': 'status'
        };
        
        const backendField = fieldMapping[sortBy] || sortBy || 'id';
        queryParams.sortBy = backendField;
        queryParams.sortDir = sortDir === 'asc' ? 'asc' : 'desc';
      }

      const response = await getInvoices(queryParams);
      const invoiceData = response.content || response.data?.content || response.data || [];

      // ✅ PAYMENT RECEIVED: Fetch all payments once and create a map for efficient lookup
      let paymentMap = new Map(); // Map<invoiceId, totalAmount>
      try {
        const paymentsResponse = await api.get('/crm/payments', {
          params: {
            page: 0,
            size: 10000 // Fetch all payments at once
          }
        });
        
        const allPayments = paymentsResponse.data?.content || paymentsResponse.data || [];
        
        // Group payments by invoiceId and sum amounts
        allPayments.forEach(payment => {
          if (payment.invoiceId) {
            const invoiceId = String(payment.invoiceId).trim();
            const amount = parseFloat(payment.amount) || 0;
            const currentTotal = paymentMap.get(invoiceId) || 0;
            paymentMap.set(invoiceId, currentTotal + amount);
          }
        });
      } catch (paymentError) {
        console.warn('Failed to fetch payments for calculation:', paymentError);
        // Continue with stored values if payment fetch fails
      }

      // ✅ PAYMENT RECEIVED: Map invoice data with paymentReceived from payments table
      const invoicesWithPayments = invoiceData.map((item) => {
        const invoiceIdStr = String(item.id).trim();
        const calculatedPaymentReceived = paymentMap.get(invoiceIdStr) || 0;
        
        return {
          ...item,
          // ✅ PAYMENT RECEIVED: Use calculated value from payments table
          paymentReceived: calculatedPaymentReceived || item.paymentReceived || item.amountReceived || 0,
          amountReceived: calculatedPaymentReceived || item.amountReceived || 0, // Also update amountReceived for consistency
          // Preserve the invoice/proposal source currency for list conversion.
          displayCurrencyCode: item.displayCurrencyCode || item.currencyCode || invoiceCurrencyCode,
          baseCurrencyCode: item.baseCurrencyCode || 'IDR',
          exchangeRateAtCreation: item.exchangeRateAtCreation || 1
        };
      });

      setInvoices(invoicesWithPayments);
      // Strictly trust server totals to avoid UI drift
      const serverTotalElements = response.totalElements ?? response.data?.totalElements ?? 0;
      const serverTotalPages = response.totalPages ?? response.data?.totalPages ?? 0;
      const serverNumber = response.currentPage ?? response.number ?? 0; // 0-based
      const serverSize = response.size ?? response.data?.size ?? (params.size ?? pagination.rowsPerPage);
      setPagination(prev => ({
        currentPage: serverNumber + 1,
        totalPages: serverTotalPages,
        totalElements: serverTotalElements,
        totalRows: serverTotalElements,
        rowsPerPage: serverSize
      }));
    } catch (error) {
      console.error('Error fetching invoices:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        statusText: error.response?.statusText
      });

      // Show error alert to user
      const errorMessage = error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        'Failed to load invoice details';

      setAlert({
        type: 'danger',
        message: errorMessage
      });

      setInvoices([]);
      setPagination(prev => ({ currentPage: 1, totalPages: 0, totalElements: 0, totalRows: 0, rowsPerPage: prev.rowsPerPage }));
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setPagination(prev => ({ ...prev, currentPage: newPage }));
    persistState({ filters: appliedFilterData, search: searchQuery, page: newPage - 1, size: pagination.rowsPerPage });
    fetchInvoices({ page: newPage, sortBy: sortConfig.key, sortDir: sortConfig.direction });
  };

  // Handle sort change from GenericView
  const handleSortChange = (newSortConfig) => {
    setSortConfig(newSortConfig);
    // Reset to page 1 and fetch with new sort
    setPagination(prev => ({ ...prev, currentPage: 1 }));
    fetchInvoices({ page: 1, sortBy: newSortConfig.key, sortDir: newSortConfig.direction });
  };

  const handleRowsPerPageChange = (newSize) => {
    setPagination(prev => ({ ...prev, rowsPerPage: newSize, currentPage: 1 }));
    persistState({ filters: appliedFilterData, search: searchQuery, page: 0, size: newSize });
    fetchInvoices({ page: 1, size: newSize, sortBy: sortConfig.key, sortDir: sortConfig.direction });
  };

  // Fetch stats
  const fetchStats = async () => {
    try {
      const response = await getInvoiceStats();
      setStats({
        total: {
          count: response.totalCount || 0,
          amount: formatCurrency(response.totalAmount || 0, invoiceCurrencyCode)
        },
        paid: {
          count: response.paidCount || 0,
          amount: formatCurrency(response.paidAmount || 0, invoiceCurrencyCode)
        },
        unpaid: {
          count: response.unpaidCount || 0,
          amount: formatCurrency(response.unpaidAmount || 0, invoiceCurrencyCode)
        },
        overdue: {
          count: response.overdueCount || 0,
          amount: formatCurrency(response.overdueAmount || 0, invoiceCurrencyCode)
        }
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
      // Don't show alert for stats error as it's not critical
      // Just set default values
      setStats({
        total: { count: 0, amount: formatCurrency(0, invoiceCurrencyCode) },
        paid: { count: 0, amount: formatCurrency(0, invoiceCurrencyCode) },
        unpaid: { count: 0, amount: formatCurrency(0, invoiceCurrencyCode) },
        overdue: { count: 0, amount: formatCurrency(0, invoiceCurrencyCode) }
      });
    }
  };

  const withInactiveBadge = (u) =>
    u.status === '0' ? { ...u, label: `${u.label} (Inactive)` } : u;

  // Cascade: filter people options by selected department; mark inactive users
  const cascadedInvoiceAssignedUsers = useMemo(() => {
    const dept = filterData.department;
    const base = (filterOptions.assignedUsers || []).map(withInactiveBadge);
    if (!dept) return base;
    return base.filter(u => { const d = u.departmentId; return d != null && String(d) === String(dept); });
  }, [filterData.department, filterOptions.assignedUsers]);

  const cascadedInvoiceCreatedByUsers = useMemo(() => {
    return (filterOptions.createdByUsers || []).map(withInactiveBadge);
  }, [filterOptions.createdByUsers]);

  const handleFilterChange = (name, value) => {
    setFilterData(prev => {
      // Period preset → compute dateFrom/dateTo automatically
      if (name === 'period') {
        if (value && value !== 'custom') {
          const r = getPeriodDateRange(value);
          return { ...prev, period: value, dateFrom: r.startDate, dateTo: r.endDate };
        }
        if (value === 'custom') {
          return { ...prev, period: 'custom', dateFrom: '', dateTo: '' };
        }
        return { ...prev, period: '', dateFrom: '', dateTo: '' };
      }
      // AdvancedFilterPanel's custom range writes to startDate/endDate keys → route to dateFrom/dateTo
      if (name === 'startDate') return { ...prev, dateFrom: value };
      if (name === 'endDate')   return { ...prev, dateTo: value };
      return { ...prev, [name]: value };
    });
  };

  const handleFilterReset = () => {
    setFilterData({ ...emptyFilter });
    setAppliedFilterData({ ...emptyFilter });
    setPagination(prev => ({ ...prev, currentPage: 1 }));
    persistState({ filters: { ...emptyFilter }, search: '', page: 0, size: pagination.rowsPerPage });
    fetchInvoices({ page: 1 }, true);
    fetchTotals();
  };

  const handleFilterApply = () => {
    setAppliedFilterData(filterData);
    setPagination(prev => ({ ...prev, currentPage: 1 }));
    persistState({ filters: filterData, search: searchQuery, page: 0, size: pagination.rowsPerPage });
    fetchInvoices({ page: 1 }, false, filterData);
    fetchTotals();
    window.bootstrap?.Offcanvas?.getInstance(document.getElementById('offcanvasInvoice'))?.hide();
  };

  // Helper: format date as dd/mm/yyyy
  const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString) return '';
    try {
      const d = new Date(dateString);
      if (Number.isNaN(d.getTime())) return dateString;
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    } catch (e) {
      return dateString;
    }
  };

  // Helper: format date with time as dd/mm/yyyy HH:mm
  const formatDateDisplay = (dateValue) => {
    if (!dateValue) return '';
  
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return '';
  
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
  
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
  
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const formatCurrency = (amount, currencyCode = invoiceCurrencyCode) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 0
    }).format(amount);
  };

  // Preview uploaded PDF for a specific invoice in the list
  const handlePreviewUploadedFromList = async (row) => {
    try {
      if (!row?.id) return;
      const response = await api.get(`/crm/invoices/${row.id}/uploaded-pdf`, { responseType: 'blob' });

      // If backend returned JSON (error), show it instead of displaying invalid PDF
      const contentType = response.headers?.['content-type'] || '';
      if (contentType.includes('application/json')) {
        const text = await response.data.text?.() || '';
        let message = 'Failed to preview uploaded PDF.';
        try {
          const json = JSON.parse(text);
          message = json.error || json.message || message;
        } catch (_) { }
        setAlert({ type: 'warning', message });
        return;
      }

      const blob = new Blob([response.data], { type: contentType || 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      // Set PDF data for modal display
      setPdfTitle(`Invoice PDF - ${row.invoiceNumber || row.id}`);
      setPdfUrl(url);
      setShowPdfModal(true);
    } catch (e) {
      console.error('Preview uploaded PDF failed:', e);
      setAlert({ type: 'danger', message: 'Failed to preview uploaded PDF.' });
    }
  };

  // Handle PDF modal close and cleanup
  const handlePdfModalClose = () => {
    setShowPdfModal(false);
    if (pdfUrl) {
      window.URL.revokeObjectURL(pdfUrl);
      setPdfUrl(null);
    }
    setPdfTitle('');
  };

  const getStatusBadge = (status) => {
    const colors = {
      'PAID': 'bg-success text-white',
      'UNPAID': 'bg-warning text-white',
      'OVERDUE': 'bg-danger text-white',
      'PARTIAL': 'bg-info text-white',
      'DRAFT': 'badge-outline text-orange',
      'SENT': 'badge-outline text-blue',
      'CANCELLED': 'badge-outline text-gray',
      'FINAL': 'bg-primary text-white'
    };
    return `badge ${colors[status] || 'badge-outline text-gray'}`;
  };

  const handleAddNew = () => {
    if (!canInvoice('create')) {
      setAlert({
        type: 'danger',
        message: 'You do not have permission to create invoices.'
      });
      return;
    }

    setIsEditMode(false);
    setEditingInvoice(null);
    setFormData({
      client: '',
      projectName: '',
      projectId: null,    // ✅ Reset projectId
      leadId: null,       // ✅ Reset leadId
      billDate: new Date().toISOString().split('T')[0],
      dueDate: '',
      description: '',
      jurnalNumber: '',
      invoiceTo: '',
      invoiceIssued: '',
      tax: 0,
      applyTax: false,
      documents: [],
      status: 'Draft',
      items: [
        {
          description: '',
          quantity: 1,
          unitPrice: 0,
          tax: 0,
          total: 0
        }
      ],
      subtotal: 0,
      total: 0,
      notes: '',
      terms: '',
      paymentMethod: '',
      bankAccount: ''
    });
    setFormErrors({});
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setIsEditMode(false);
    setEditingInvoice(null);
    setFormErrors({}); // Clear form errors when modal closes
  };

  const handleInputChange = (name, value) => {
    // ✅ AUTO-CHECK APPLY TAX: Automatically check applyTax when tax percentage is not 0
    if (name === 'tax') {
      const taxValue = typeof value === 'string' ? parseFloat(value) || 0 : (value || 0);
      setFormData(prev => ({
        ...prev,
        tax: taxValue,
        applyTax: taxValue > 0 // Automatically check if tax > 0, uncheck if tax = 0
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }

    // Clear error when field is edited
    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  // Validate individual field on blur
  const handleFieldBlur = (name, value) => {
    const validationData = {
      [name]: value,
      isEditMode: isEditMode
    };
    const errors = validateInvoiceForm(validationData);

    if (errors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: errors[name]
      }));
    }
  };

  const handleFormSubmit = async (e, onSuccess, formDataFromChild = null) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Use form data from child component if provided, otherwise use local formData
    const dataToValidate = formDataFromChild || formData;

    // Validate form using the validation utility
    const validationData = {
      ...dataToValidate,
      isEditMode: isEditMode
    };
    const errors = validateInvoiceForm(validationData);

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      setIsSubmitting(false);
      return;
    }

    try {
      // Clear any existing errors
      setFormErrors({});

      // ✅ FIX: Prioritas projectId untuk edit, projectName untuk create
      const projectIdToSend = isEditMode
        ? (dataToValidate.projectId || dataToValidate.projectName || editingInvoice?.projectId)
        : (dataToValidate.projectName || dataToValidate.projectId);

      // ✅ CALCULATION: Send only raw values to backend - let backend calculate totals
      // Frontend calculation is only for UI preview, backend is source of truth
      const subtotal = dataToValidate.subtotal || 0;
      const taxPercentage = dataToValidate.tax || 0;
      const applyTax = dataToValidate.applyTax || false;

      // ✅ FIX STATUS: Same behavior as InvoiceView - don't send status when editing (backend preserves it)
      // Only send status for new invoices (default to DRAFT)
      const payload = {
        companyId: dataToValidate.client,
        // ✅ PROJECT RELATION: Send projectId dengan prioritas yang benar
        projectId: projectIdToSend,
        billDate: dataToValidate.billDate,
        dueDate: dataToValidate.dueDate,
        description: dataToValidate.description,
        jurnalNumber: dataToValidate.jurnalNumber || '',
        invoiceTo: dataToValidate.invoiceTo || '',
        invoiceIssued: dataToValidate.invoiceIssued || '',
        taxPercentage: taxPercentage,
        applyTax: applyTax,
        subtotal: subtotal,
        dppLainnya: dataToValidate.dppLainnya || 0,
        // ✅ Don't send ppn, total, balanceDue - backend will calculate them
        amountReceived: dataToValidate.amountReceived || 0,
        message: dataToValidate.message || '',
        notes: dataToValidate.notes || '',
        terms: dataToValidate.terms || '',
        paymentMethod: dataToValidate.paymentMethod || '',
        bankAccount: dataToValidate.bankAccount || ''
      };

      // ✅ Only include status for new invoices (create mode), not when editing
      if (!isEditMode) {
        payload.status = 'DRAFT';
      }

      let response;
      const file = dataToValidate.documents?.[0]?.file;

      // Validate file size before upload (guard against server MULTIPART_ERROR)
      const MAX_FILE_SIZE_MB = 5;
      if (file && file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
        setAlert({
          type: 'danger',
          message: `File terlalu besar (${(file.size / 1024 / 1024).toFixed(1)} MB). Maksimal ukuran file adalah ${MAX_FILE_SIZE_MB} MB. Harap kompres PDF terlebih dahulu (gunakan ilovepdf.com atau sejenisnya).`
        });
        setIsSubmitting(false);
        return;
      }

      if (isEditMode) {
        if (file) {
          // PUT with file: multipart blob
          const fd = new FormData();
          fd.append('invoice', new Blob([JSON.stringify(payload)], { type: 'application/json' }), 'invoice.json');
          fd.append('file', file, file.name);
          response = await api.put(`/crm/invoices/${editingInvoice.id}`, fd, {
            maxBodyLength: Infinity,
            maxContentLength: Infinity,
          });
        } else {
          // PUT without file: plain JSON
          response = await api.put(`/crm/invoices/${editingInvoice.id}`, payload);
        }
      } else {
        // POST endpoint ONLY accepts multipart/form-data — always use blob approach
        const fd = new FormData();
        fd.append('invoice', new Blob([JSON.stringify(payload)], { type: 'application/json' }), 'invoice.json');
        if (file) fd.append('file', file, file.name);
        response = await api.post('/crm/invoices', fd, {
          maxBodyLength: Infinity,
          maxContentLength: Infinity,
        });
      }

      if (response.data.success) {
        // Show success message
        setAlert({
          type: 'success',
          message: isEditMode ? 'Invoice updated successfully!' : 'Invoice created successfully!'
        });

        // Refresh data
        fetchInvoices();
        fetchStats();

        if (onSuccess) {
          onSuccess();
        }

        // ✅ Auto-redirect to the created invoice detail page
        if (!isEditMode && response.data.id) {
          navigate(`/invoice/${response.data.id}`);
        }
      } else {
        console.error('❌ BACKEND ERROR: Error saving invoice:', response.data.error || 'Failed to save invoice');
        console.error('Full response:', response);
        setAlert({
          type: 'danger',
          message: response.data.error || 'Failed to save invoice. Please try again.'
        });
      }
      setIsSubmitting(false);
    } catch (error) {
      console.error('❌ FRONTEND ERROR: Error submitting form:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        statusText: error.response?.statusText
      });

      // Show specific error message from backend if available
      const rawError = error.response?.data?.error ||
        error.response?.data?.message ||
        (typeof error.response?.data === 'string' ? error.response.data : '') ||
        error.message || '';

      let errorMessage = rawError || 'Failed to submit invoice. Please try again.';

      // File too large (413 or size-related errors)
      const isFileTooLarge = rawError.includes('Maximum upload size exceeded') ||
        rawError.includes('FileSizeLimitExceededException') ||
        error.response?.status === 413;

      if (isFileTooLarge) {
        errorMessage = 'Ukuran file PDF terlalu besar dan ditolak oleh server. Harap kompres PDF terlebih dahulu (gunakan ilovepdf.com atau sejenisnya) lalu coba lagi.';
      } else if (!error.response && (error.message === 'Network Error' || error.code === 'ERR_NETWORK')) {
        errorMessage = 'Network Error: Tidak dapat terhubung ke server. Pastikan server berjalan dan coba lagi.';
      }

      setAlert({
        type: 'danger',
        message: errorMessage
      });
      setIsSubmitting(false);
    }
  };

  const columns = [
    {
      key: 'uploadedPdf',
      label: 'PDF',
      render: (value, item) => (
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); handlePreviewUploadedFromList(item); }}
          title={item?.documentPath ? 'Download Uploaded PDF' : 'Try download (will warn if not uploaded)'}
        >
          <FileText className="icon-tabler icon-tabler-download" width="18" height="18" />
        </a>
      )
    },
    {
      key: 'invoiceNumber',
      label: 'Invoice Number',
      className: 'text-truncate',
      sortValue: (item) => item.invoiceNumber || item.id || '',
      render: (value, item) => (
        <a
          href={`/invoice/${item.id}`}
          className="text-primary text-truncate d-inline-block text-decoration-none"
          style={{ cursor: 'pointer', maxWidth: '120px', width: '120px' }}
          onClick={(e) => {
            // Allow right-click, Ctrl+Click, Cmd+Click to open in new tab
            if (e.ctrlKey || e.metaKey || e.button === 1) {
              return; // Let browser handle it
            }
            e.preventDefault();
            navigate(`/invoice/${item.id}`);
          }}
          onAuxClick={(e) => {
            // Handle middle mouse button click
            if (e.button === 1) {
              return; // Let browser handle it
            }
          }}
          title={value || item.id}
        >
          {value || item.id}
        </a>
      )
    },
    {
      key: 'jurnalNumber',
      label: 'Jurnal Number',
      className: 'text-truncate',
      sortValue: (item) => item.jurnalNumber || '',
      render: (value) => (
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: '150px', width: '150px' }}
          title={value}
        >
          {value || '-'}
        </span>
      )
    },
    {
      key: 'departmentName',
      label: 'Department',
      className: 'text-truncate',
      sortValue: (item) => item.departmentName || '',
      render: (value) => (
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: '150px', width: '150px' }}
          title={value}
        >
          {value}
        </span>
      )
    },
    {
      key: 'client',
      label: 'Client',
      className: 'text-truncate',
      sortValue: (item) => item.client || '',
      render: (value) => (
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: '200px', width: '200px' }}
          title={value}
        >
          {value}
        </span>
      )
    },
    {
      key: 'tagging',
      label: 'Tagging',
      sortable: false,
      className: 'text-truncate',
      render: (value) => {
        const tags = value ? String(value).split(',').map(s => s.trim()).filter(Boolean) : [];
        if (tags.length === 0) return <span className="text-muted">-</span>;
        return (
          <span className="d-inline-flex flex-wrap gap-1" style={{ maxWidth: '180px' }}>
            {tags.map((tag, i) => (
              <span key={i} className="badge bg-blue-lt text-wrap" title={tag} style={{ fontSize: '0.7rem' }}>
                {tag}
              </span>
            ))}
          </span>
        );
      }
    },
    {
      key: 'description',
      label: 'Description',
      className: 'text-truncate',
      sortValue: (item) => item.description || '',
      render: (value) => (
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: '250px', width: '250px' }}
          title={value}
        >
          {value}
        </span>
      )
    },
    {
      key: 'invoiceTo',
      label: 'Invoice To',
      className: 'text-truncate',
      sortValue: (item) => item.invoiceTo || '',
      render: (value) => (
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: '180px', width: '180px' }}
          title={value}
        >
          {value || '-'}
        </span>
      )
    },
    {
      key: 'invoiceIssued',
      label: 'Term of Payments',
      className: 'text-truncate',
      sortValue: (item) => item.invoiceIssued || '',
      render: (value) => {
        const displayValue = formatInvoiceIssuedLabel(value);
        return (
          <span
            className="text-truncate d-inline-block"
            style={{ maxWidth: '140px', width: '140px' }}
            title={displayValue}
          >
            {displayValue || '-'}
          </span>
        );
      }
    },
    {
      key: 'projectName',
      label: 'Project',
      className: 'text-truncate',
      sortValue: (item) => item.projectName || '',
      render: (value) => (
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: '200px', width: '200px' }}
          title={value}
        >
          {value}
        </span>
      )
    },
    {
      key: 'proposalCode',
      label: 'Order Number',
      className: 'text-truncate',
      sortValue: (item) => item?.proposalCode || item?.proposal_code || '',
      render: (value, item) => {
        const orderNumber = item?.proposalCode || item?.proposal_code || '';
        return (
          <span
            className="text-truncate d-inline-block"
            style={{ maxWidth: '200px', width: '200px' }}
            title={orderNumber}
          >
            {orderNumber || '-'}
          </span>
        );
      }
    },
    {
      key: 'subtotal',
      label: 'Sub Total',
      className: 'text-truncate',
      sortValue: (item) => item.subtotal || 0,
      render: (value, item) => {
        // ✅ MULTI-CURRENCY: Gunakan display currency dari invoice atau fallback ke invoiceCurrencyCode
        const formattedValue = formatCurrency(toIdrAmount(value, item), 'IDR');
        return (
          <span
            className="text-truncate d-inline-block"
            style={{ maxWidth: '150px', width: '150px' }}
            title={formattedValue}
          >
            {formattedValue}
          </span>
        );
      }
    },
    {
      key: 'ppn',
      label: 'PPN',
      className: 'text-truncate',
      sortValue: (item) => item.ppn || 0,
      render: (value, item) => {
        // ✅ MULTI-CURRENCY: Gunakan display currency dari invoice atau fallback ke invoiceCurrencyCode
        const formattedValue = formatCurrency(toIdrAmount(value, item), 'IDR');
        return (
          <span
            className="text-truncate d-inline-block"
            style={{ maxWidth: '150px', width: '150px' }}
            title={formattedValue}
          >
            {formattedValue}
          </span>
        );
      }
    },
    {
      key: 'totalInvoiced',
      label: 'Total Invoiced',
      className: 'text-truncate',
      sortValue: (item) => item.totalInvoiced || 0,
      render: (value, item) => {
        // ✅ MULTI-CURRENCY: Gunakan display currency dari invoice atau fallback ke invoiceCurrencyCode
        const formattedValue = formatCurrency(toIdrAmount(value, item), 'IDR');
        return (
          <span
            className="text-truncate d-inline-block"
            style={{ maxWidth: '150px', width: '150px' }}
            title={formattedValue}
          >
            {formattedValue}
          </span>
        );
      }
    },
    {
      key: 'paymentReceived',
      label: 'Payment Received',
      className: 'text-truncate',
      sortValue: (item) => item.paymentReceived || 0,
      render: (value, item) => {
        // ✅ MULTI-CURRENCY: Gunakan display currency dari invoice atau fallback ke invoiceCurrencyCode
        const formattedValue = formatCurrency(toIdrAmount(value, item), 'IDR');
        return (
          <span
            className="text-truncate d-inline-block"
            style={{ maxWidth: '150px', width: '150px' }}
            title={formattedValue}
          >
            {formattedValue}
          </span>
        );
      }
    },
    {
      key: 'due',
      label: 'Due',
      className: 'text-truncate',
      sortValue: (item) => item.due || 0,
      render: (value, item) => {
        // ✅ MULTI-CURRENCY: Gunakan display currency dari invoice atau fallback ke invoiceCurrencyCode
        const formattedValue = formatCurrency(toIdrAmount(value, item), 'IDR');
        return (
          <span
            className="text-truncate d-inline-block"
            style={{ maxWidth: '150px', width: '150px' }}
            title={`${formattedValue} - Total invoice amount due by due date`}
          >
            {formattedValue}
          </span>
        );
      }
    },
    {
      key: 'balance',
      label: 'Balance',
      className: 'text-truncate',
      sortValue: (item) => item.balance || 0,
      render: (value, item) => {
        // ✅ MULTI-CURRENCY: Gunakan display currency dari invoice atau fallback ke invoiceCurrencyCode
        const formattedValue = formatCurrency(toIdrAmount(value, item), 'IDR');
        return (
          <span
            className="text-truncate d-inline-block"
            style={{ maxWidth: '150px', width: '150px' }}
            title={`${formattedValue} - Remaining amount after payments`}
          >
            {formattedValue}
          </span>
        );
      }
    },
    {
      key: 'billDate',
      label: 'Bill Date',
      type: 'date',
      className: 'text-truncate',
      sortValue: (item) => item.billDate || '',
      render: (value) => {
        const dateValue = formatDateDisplay(value);
        return (
          <span
            className="text-truncate d-inline-block"
            style={{ maxWidth: '140px', width: '140px' }}
            title={dateValue}
          >
            {dateValue}
          </span>
        );
      }
    },
    {
      key: 'dueDate',
      label: 'Due Date',
      type: 'date',
      className: 'text-truncate',
      sortValue: (item) => item.dueDate || '',
      render: (value) => {
        const dateValue = formatDateDisplay(value);
        return (
          <span
            className="text-truncate d-inline-block"
            style={{ maxWidth: '140px', width: '140px' }}
            title={dateValue}
          >
            {dateValue}
          </span>
        );
      }
    },
    {
      key: 'assignedUserName',
      label: 'Assigned To',
      className: 'text-truncate',
      sortValue: (item) => item.assignedUserName || '',
      render: (value) => (
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: '160px', width: '160px' }}
          title={value}
        >
          {value}
        </span>
      )
    },
    {
      key: 'createdByName',
      label: 'Created By',
      className: 'text-truncate',
      sortValue: (item) => item.createdByName || '',
      render: (value) => (
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: '160px', width: '160px' }}
          title={value}
        >
          {value}
        </span>
      )
    },
    {
      key: 'updatedByName',
      label: 'Updated By',
      className: 'text-truncate',
      sortValue: (item) => item.updatedByName || '',
      render: (value) => (
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: '160px', width: '160px' }}
          title={value}
        >
          {value}
        </span>
      )
    },
    {
      key: 'serviceName',
      label: 'Service',
      className: 'text-truncate',
      sortValue: (item) => item.serviceName || '',
      render: (value) => (
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: '150px', width: '150px' }}
          title={value}
        >
          {value}
        </span>
      )
    },
    {
      key: 'status',
      label: 'Status',
      className: 'text-truncate',
      sortValue: (item) => {
        const status = item.status || '';
        return status === 'SENT' ? 'SENT TO FINANCE' : status;
      },
      render: (value) => {
        const statusText = value === 'SENT' ? 'SENT TO FINANCE' : value;
        return (
          <span
            className={`${getStatusBadge(value)} text-truncate d-inline-block`}
            style={{ maxWidth: '150px', width: '150px' }}
            title={statusText}
          >
            {statusText}
          </span>
        );
      }
    }
  ];

  const handleEditInvoice = async (invoice) => {
    if (!canInvoice('edit')) {
      setAlert({
        type: 'danger',
        message: 'You do not have permission to edit invoices.'
      });
      return;
    }

    try {
      // Fetch full invoice details
      const fullInvoiceData = await getInvoice(invoice.id);

      // Set form data with full invoice data for editing
      setIsEditMode(true);
      setEditingInvoice(fullInvoiceData);
      setFormData({
        client: fullInvoiceData.companyId || fullInvoiceData.client || '',
        projectName: fullInvoiceData.projectId || fullInvoiceData.projectName || '',
        projectId: fullInvoiceData.projectId || null,
        leadId: fullInvoiceData.leadId || null,
        billDate: fullInvoiceData.billDate || new Date().toISOString().split('T')[0],
        dueDate: fullInvoiceData.dueDate || '',
        description: fullInvoiceData.description || '',
        jurnalNumber: fullInvoiceData.jurnalNumber || '',
        invoiceTo: fullInvoiceData.invoiceTo || '',
        invoiceIssued: fullInvoiceData.invoiceIssued || '',
        tax: fullInvoiceData.taxPercentage || fullInvoiceData.tax || 0,
        documents: fullInvoiceData.documentPath ? [{
          name: fullInvoiceData.documentPath.split('/').pop(),
          url: fullInvoiceData.documentPath,
          uploaded: true
        }] : [],
        status: fullInvoiceData.status || 'Draft',
        items: fullInvoiceData.items || [],
        subtotal: fullInvoiceData.subtotal || 0,
        dppLainnya: fullInvoiceData.dppLainnya || 0,
        ppn: fullInvoiceData.ppn || 0,
        total: fullInvoiceData.total || 0,
        amountReceived: fullInvoiceData.amountReceived || 0,
        balanceDue: fullInvoiceData.balanceDue || 0,
        message: fullInvoiceData.message || '',
        notes: fullInvoiceData.notes || '',
        terms: fullInvoiceData.terms || '',
        paymentMethod: fullInvoiceData.paymentMethod || '',
        bankAccount: fullInvoiceData.bankAccount || ''
      });
      setFormErrors({});
      setIsModalOpen(true);
    } catch (error) {
      console.error('Error fetching invoice details:', error);
      setAlert({
        type: 'danger',
        message: 'Failed to load invoice details. Please try again.'
      });
    }
  };

  const handleRowClick = (invoice) => {
    navigate(`/invoice/${invoice.id}`);
  };

  // Initialize visible columns when columns are defined
  useEffect(() => {
    if (columns.length > 0 && visibleColumns.length === 0) {
      setVisibleColumns(columns.map(col => col.key));
    }
  }, [columns.length, visibleColumns.length]);

  const handleDeleteInvoice = (invoice) => {
    if (!canInvoice('delete')) {
      setAlert({
        type: 'danger',
        message: 'You do not have permission to delete invoices.'
      });
      return;
    }
    setItemToDelete(invoice);
    setShowDeleteModal(true);
  };

  const confirmDeleteInvoice = async () => {
    try {
      await deleteInvoice(itemToDelete.id);
      fetchInvoices(); // Refresh the list
      fetchStats(); // Refresh stats
      setAlert({
        type: 'success',
        message: 'Invoice deleted successfully!'
      });
    } catch (error) {
      console.error('Error deleting invoice:', error);
      setAlert({
        type: 'danger',
        message: 'Failed to delete invoice. Please try again.'
      });
    }
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  const handleFinalizeInvoice = (invoice) => {
    if (!canInvoice('can_finalize')) {
      setAlert({
        type: 'danger',
        message: 'You do not have permission to finalize invoices.'
      });
      return;
    }

    // Check if already final
    if (invoice.status === 'FINAL') {
      setAlert({
        type: 'warning',
        message: 'This invoice is already finalized.'
      });
      return;
    }

    setItemToFinalize(invoice);
    setShowFinalizeModal(true);
  };

  const confirmFinalizeInvoice = async () => {
    try {
      // Call API to update invoice status to FINAL
      await api.put(`/crm/invoices/${itemToFinalize.id}/finalize`);

      fetchInvoices(); // Refresh the list
      fetchStats(); // Refresh stats
      setAlert({
        type: 'success',
        message: 'Invoice finalized successfully!'
      });
    } catch (error) {
      console.error('Error finalizing invoice:', error);
      const errorMessage = error.response?.data?.error ||
        error.response?.data?.message ||
        'Failed to finalize invoice. Please try again.';
      setAlert({
        type: 'danger',
        message: errorMessage
      });
    }
    setShowFinalizeModal(false);
    setItemToFinalize(null);
  };

  const handleExportExcel = async () => {
    if (!canInvoice('export_data')) {
      setAlert({
        type: 'danger',
        message: 'You do not have permission to export data.'
      });
      return;
    }

    try {
      let dataToExport = [];
      
      // ✅ EXPORT LOGIC: If rows are selected, export only selected rows
      // Otherwise, export all data (with filters if applied) ignoring pagination
      if (selectedRows && selectedRows.length > 0) {
        // Export only selected rows (match IDs from current invoices)
        const selectedInvoiceIds = selectedRows.map(id => String(id));
        dataToExport = invoices.filter(row => selectedInvoiceIds.includes(String(row.id)));
      } else {
        // Export all data - fetch all invoices without pagination
        // If filters are applied, use them to export only filtered items
        setLoading(true);
        try {
          const queryParams = buildExportQueryParams();
          const allInvoicesResponse = await getInvoices(queryParams);
          const allInvoicesData = allInvoicesResponse.content || allInvoicesResponse.data?.content || allInvoicesResponse.data || [];
          
          // ✅ PAYMENT RECEIVED: Fetch all payments once and create a map for efficient lookup
          let paymentMap = new Map(); // Map<invoiceId, totalAmount>
          try {
            const paymentsResponse = await api.get('/crm/payments', {
              params: {
                page: 0,
                size: 10000 // Fetch all payments at once
              }
            });
            
            const allPayments = paymentsResponse.data?.content || paymentsResponse.data || [];
            
            // Group payments by invoiceId and sum amounts
            allPayments.forEach(payment => {
              if (payment.invoiceId) {
                const invoiceId = String(payment.invoiceId).trim();
                const amount = parseFloat(payment.amount) || 0;
                const currentTotal = paymentMap.get(invoiceId) || 0;
                paymentMap.set(invoiceId, currentTotal + amount);
              }
            });
          } catch (paymentError) {
            console.warn('Failed to fetch payments for export calculation:', paymentError);
            // Continue with stored values if payment fetch fails
          }

          // ✅ PAYMENT RECEIVED: Map invoice data with paymentReceived from payments table
          const mappedAllInvoices = allInvoicesData.map((item) => {
            const invoiceIdStr = String(item.id).trim();
            const calculatedPaymentReceived = paymentMap.get(invoiceIdStr) || 0;
            
            return {
              ...item,
              // ✅ PAYMENT RECEIVED: Use calculated value from payments table
              paymentReceived: calculatedPaymentReceived || item.paymentReceived || item.amountReceived || 0,
              amountReceived: calculatedPaymentReceived || item.amountReceived || 0,
              // ✅ MULTI-CURRENCY: Map with currency information
              displayCurrencyCode: item.displayCurrencyCode || item.currencyCode || invoiceCurrencyCode,
              baseCurrencyCode: item.baseCurrencyCode || 'IDR',
              exchangeRateAtCreation: item.exchangeRateAtCreation || 1
            };
          });
          
          dataToExport = mappedAllInvoices;
        } catch (error) {
          console.error('Error fetching all invoices for export:', error);
          // Fallback to current page invoices if fetch fails
          dataToExport = invoices;
        } finally {
          setLoading(false);
        }
      }

      // ✅ COLUMN FILTERING: Create mapping of column keys to export field names
      // ✅ NUMERIC COLUMNS: Export as numbers for Excel sum functionality
      const columnExportMap = {
        'uploadedPdf': { label: 'PDF', value: () => '', isNumeric: false },
        'invoiceNumber': { label: 'Invoice Number', value: (row) => row.invoiceNumber || '', isNumeric: false },
        'jurnalNumber': { label: 'Jurnal Number', value: (row) => row.jurnalNumber || '', isNumeric: false },
        'departmentName': { label: 'Department', value: (row) => row.departmentName || '', isNumeric: false },
        'client': { label: 'Client', value: (row) => row.client || '', isNumeric: false },
        'description': { label: 'Description', value: (row) => row.description || '', isNumeric: false },
        'invoiceTo': { label: 'Invoice To', value: (row) => row.invoiceTo || '', isNumeric: false },
        'invoiceIssued': { label: 'Term of Payments', value: (row) => formatInvoiceIssuedLabel(row.invoiceIssued), isNumeric: false },
        'projectName': { label: 'Project', value: (row) => row.projectName || '', isNumeric: false },
        'proposalCode': { label: 'Order Number', value: (row) => row.proposalCode || row.proposal_code || '', isNumeric: false },
        'subtotal': { label: 'Sub Total', value: (row) => {
          // ✅ Export as number, not formatted string
          return toIdrAmount(row.subtotal, row);
        }, isNumeric: true },
        'ppn': { label: 'PPN', value: (row) => {
          // ✅ Export as number, not formatted string
          return toIdrAmount(row.ppn, row);
        }, isNumeric: true },
        'totalInvoiced': { label: 'Total Invoiced', value: (row) => {
          // ✅ Export as number, not formatted string
          return toIdrAmount(row.totalInvoiced, row);
        }, isNumeric: true },
        'paymentReceived': { label: 'Payment Received', value: (row) => {
          // ✅ Export as number, not formatted string
          return toIdrAmount(row.paymentReceived, row);
        }, isNumeric: true },
        'due': { label: 'Due', value: (row) => {
          // ✅ Export as number, not formatted string
          return toIdrAmount(row.due, row);
        }, isNumeric: true },
        'billDate': { label: 'Bill Date', value: (row) => formatDateToDDMMYYYY(row.billDate), isNumeric: false },
        'dueDate': { label: 'Due Date', value: (row) => formatDateToDDMMYYYY(row.dueDate), isNumeric: false },
        'assignedUserName': { label: 'Assigned To', value: (row) => row.assignedUserName || '', isNumeric: false },
        'createdByName': { label: 'Created By', value: (row) => row.createdByName || '', isNumeric: false },
        'updatedByName': { label: 'Updated By', value: (row) => row.updatedByName || '', isNumeric: false },
        'serviceName': { label: 'Service', value: (row) => row.serviceName || '', isNumeric: false },
        'balance': { label: 'Balance', value: (row) => {
          // ✅ Export as number, not formatted string
          return parseFloat(row.balance) || 0;
        }, isNumeric: true },
        'status': { label: 'Status', value: (row) => row.status === 'SENT' ? 'SENT TO FINANCE' : (row.status || 'Draft'), isNumeric: false }
      };

      // ✅ COLUMN FILTERING: Filter to only include visible columns
      const visibleColumnKeys = visibleColumns.length > 0 ? visibleColumns : columns.map(col => col.key);
      const exportColumns = visibleColumnKeys
        .filter(key => columnExportMap[key]) // Only include columns that have export mapping
        .map(key => ({
          key,
          label: columnExportMap[key].label,
          value: columnExportMap[key].value,
          isNumeric: columnExportMap[key].isNumeric || false
        }));

      // Prepare data for Excel export (only visible columns)
      const excelData = dataToExport.map(row => {
        const rowData = { 'ID': row.id || '' }; // Always include ID
        exportColumns.forEach(col => {
          rowData[col.label] = col.value(row);
        });
        return rowData;
      });

      // Create worksheet from data
      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // ✅ NUMERIC COLUMNS: Set cell types and number formats for numeric columns with currency support
      // Get the range of the worksheet
      const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1');
      
      // Find numeric column indices (column B = 1, since A is ID)
      const numericColumnIndices = [];
      exportColumns.forEach((col, idx) => {
        if (col.isNumeric) {
          numericColumnIndices.push(idx + 1); // +1 because ID is first column (column A = 0)
        }
      });

      // Excel currency format codes
      const getCurrencyFormat = (currencyCode) => {
        switch (currencyCode) {
          case 'USD': return '"$"#,##0'; // $1,000
          case 'EUR': return '#,##0" €"'; // 1,000 €
          case 'GBP': return '"£"#,##0'; // £1,000
          case 'JPY': return '¥#,##0'; // ¥1,000
          case 'SGD': return '"S$"#,##0'; // S$1,000
          case 'AUD': return '"A$"#,##0'; // A$1,000
          case 'IDR': return '"Rp"#,##0'; // Rp1,000
          default: return '#,##0'; // Default: thousand separator, no decimals
        }
      };

      // Set cell types and number formats for numeric columns
      // Skip header row (range.s.r), process data rows starting from range.s.r + 1
      for (let rowNum = range.s.r + 1; rowNum <= range.e.r; rowNum++) {
        // Get the data row index (0-based for dataToExport array)
        const dataRowIndex = rowNum - range.s.r - 1;
        const rowData = dataToExport[dataRowIndex];
        
        // Get currency code for this invoice
        const currencyCode = rowData?.displayCurrencyCode || 
                            rowData?.currencyCode || 
                            invoiceCurrencyCode || 
                            'IDR';
        const currencyFormat = getCurrencyFormat(currencyCode);
        
        numericColumnIndices.forEach(colIndex => {
          const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colIndex });
          const cell = worksheet[cellAddress];
          if (cell && cell.v !== undefined && cell.v !== null && cell.v !== '') {
            // Set cell type to number
            cell.t = 'n'; // n = number type
            // Set number format based on currency (with currency symbol)
            cell.z = currencyFormat;
          }
        });
      }

      // Set column widths for better readability (only for visible columns)
      const columnWidths = [{ wch: 10 }]; // ID
      const widthMap = {
        'Invoice Number': 20,
        'Order Number': 20,
        'Client': 25,
        'Project': 25,
        'Description': 30,
        'Sub Total': 18,
        'PPN': 18,
        'Total Invoiced': 18,
        'Payment Received': 18,
        'Due': 15,
        'Bill Date': 15,
        'Due Date': 15,
        'Assigned To': 20,
        'Created By': 20,
        'Updated By': 20,
        'Service': 18,
        'Department': 18,
        'Balance': 15,
        'Status': 18
      };
      exportColumns.forEach(col => {
        columnWidths.push({ wch: widthMap[col.label] || 15 });
      });
      worksheet['!cols'] = columnWidths;

      // Create workbook and add the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Invoices');

      // Generate file name with timestamp
      const timestamp = new Date().toISOString().slice(0, 10).replace(/-/g, '');
      const fileName = `invoices_export_${timestamp}.xlsx`;

      // Write and download the file
      XLSX.writeFile(workbook, fileName);

      setAlert({
        type: 'success',
        message: selectedRows && selectedRows.length > 0 
          ? `${selectedRows.length} selected invoice(s) exported to Excel successfully!`
          : hasActiveFilters()
          ? `${dataToExport.length} filtered invoice(s) exported to Excel successfully!`
          : 'All invoices exported to Excel successfully!'
      });
    } catch (e) {
      console.error('Export Excel failed:', e);
      setAlert({
        type: 'danger',
        message: 'Failed to export invoices to Excel. Please try again.'
      });
    }
  };

  const handleExportPDF = async () => {
    if (!canInvoice('export_data')) {
      setAlert({
        type: 'danger',
        message: 'You do not have permission to export data.'
      });
      return;
    }

    try {
      let dataToExport = [];
      
      // ✅ EXPORT LOGIC: If rows are selected, export only selected rows
      // Otherwise, export all data (with filters if applied) ignoring pagination
      if (selectedRows && selectedRows.length > 0) {
        // Export only selected rows (match IDs from current invoices)
        const selectedInvoiceIds = selectedRows.map(id => String(id));
        dataToExport = invoices.filter(row => selectedInvoiceIds.includes(String(row.id)));
      } else {
        // Export all data - fetch all invoices without pagination
        // If filters are applied, use them to export only filtered items
        setLoading(true);
        try {
          const queryParams = buildExportQueryParams();
          const allInvoicesResponse = await getInvoices(queryParams);
          const allInvoicesData = allInvoicesResponse.content || allInvoicesResponse.data?.content || allInvoicesResponse.data || [];
          
          // ✅ PAYMENT RECEIVED: Fetch all payments once and create a map for efficient lookup
          let paymentMap = new Map(); // Map<invoiceId, totalAmount>
          try {
            const paymentsResponse = await api.get('/crm/payments', {
              params: {
                page: 0,
                size: 10000 // Fetch all payments at once
              }
            });
            
            const allPayments = paymentsResponse.data?.content || paymentsResponse.data || [];
            
            // Group payments by invoiceId and sum amounts
            allPayments.forEach(payment => {
              if (payment.invoiceId) {
                const invoiceId = String(payment.invoiceId).trim();
                const amount = parseFloat(payment.amount) || 0;
                const currentTotal = paymentMap.get(invoiceId) || 0;
                paymentMap.set(invoiceId, currentTotal + amount);
              }
            });
          } catch (paymentError) {
            console.warn('Failed to fetch payments for export calculation:', paymentError);
            // Continue with stored values if payment fetch fails
          }

          // ✅ PAYMENT RECEIVED: Map invoice data with paymentReceived from payments table
          const mappedAllInvoices = allInvoicesData.map((item) => {
            const invoiceIdStr = String(item.id).trim();
            const calculatedPaymentReceived = paymentMap.get(invoiceIdStr) || 0;
            
            return {
              ...item,
              // ✅ PAYMENT RECEIVED: Use calculated value from payments table
              paymentReceived: calculatedPaymentReceived || item.paymentReceived || item.amountReceived || 0,
              amountReceived: calculatedPaymentReceived || item.amountReceived || 0,
              // ✅ MULTI-CURRENCY: Map with currency information
              displayCurrencyCode: item.displayCurrencyCode || item.currencyCode || invoiceCurrencyCode,
              baseCurrencyCode: item.baseCurrencyCode || 'IDR',
              exchangeRateAtCreation: item.exchangeRateAtCreation || 1
            };
          });
          
          dataToExport = mappedAllInvoices;
        } catch (error) {
          console.error('Error fetching all invoices for export:', error);
          // Fallback to current page invoices if fetch fails
          dataToExport = invoices;
        } finally {
          setLoading(false);
        }
      }

      const win = window.open('', '_blank');
      if (!win) return;

      const style = `
        <style>
          body { font-family: Arial, sans-serif; padding: 16px; }
          h2 { margin: 0 0 12px 0; }
          table { border-collapse: collapse; width: 100%; }
          th, td { border: 1px solid #ccc; padding: 8px; text-align: left; font-size: 12px; }
          th { background: #f5f5f5; }
        </style>
      `;

      // ✅ COLUMN FILTERING: Use same column mapping for PDF export
      const columnExportMap = {
        'uploadedPdf': { label: 'PDF', value: () => '' },
        'invoiceNumber': { label: 'Invoice Number', value: (row) => row.invoiceNumber || '' },
        'jurnalNumber': { label: 'Jurnal Number', value: (row) => row.jurnalNumber || '' },
        'departmentName': { label: 'Department', value: (row) => row.departmentName || '' },
        'client': { label: 'Client', value: (row) => row.client || '' },
        'description': { label: 'Description', value: (row) => row.description || '' },
        'invoiceTo': { label: 'Invoice To', value: (row) => row.invoiceTo || '' },
        'invoiceIssued': { label: 'Term of Payments', value: (row) => formatInvoiceIssuedLabel(row.invoiceIssued) },
        'projectName': { label: 'Project', value: (row) => row.projectName || '' },
        'proposalCode': { label: 'Order Number', value: (row) => row.proposalCode || row.proposal_code || '' },
        'subtotal': { label: 'Sub Total', value: (row) => {
          return formatCurrency(row.subtotal || 0, 'IDR');
        }},
        'ppn': { label: 'PPN', value: (row) => {
          return formatCurrency(row.ppn || 0, 'IDR');
        }},
        'totalInvoiced': { label: 'Total Invoiced', value: (row) => {
          return formatCurrency(row.totalInvoiced, 'IDR');
        }},
        'paymentReceived': { label: 'Payment Received', value: (row) => {
          return formatCurrency(row.paymentReceived, 'IDR');
        }},
        'due': { label: 'Due', value: (row) => {
          return formatCurrency(row.due, 'IDR');
        }},
        'billDate': { label: 'Bill Date', value: (row) => formatDateToDDMMYYYY(row.billDate) },
        'dueDate': { label: 'Due Date', value: (row) => formatDateToDDMMYYYY(row.dueDate) },
        'assignedUserName': { label: 'Assigned To', value: (row) => row.assignedUserName || '' },
        'createdByName': { label: 'Created By', value: (row) => row.createdByName || '' },
        'updatedByName': { label: 'Updated By', value: (row) => row.updatedByName || '' },
        'serviceName': { label: 'Service', value: (row) => row.serviceName || '' },
        'balance': { label: 'Balance', value: (row) => {
          return formatCurrency(row.balance, 'IDR');
        }},
        'status': { label: 'Status', value: (row) => row.status === 'SENT' ? 'SENT TO FINANCE' : (row.status || 'Draft') }
      };

      // ✅ COLUMN FILTERING: Filter to only include visible columns
      const visibleColumnKeys = visibleColumns.length > 0 ? visibleColumns : columns.map(col => col.key);
      const exportColumns = visibleColumnKeys
        .filter(key => columnExportMap[key]) // Only include columns that have export mapping
        .map(key => ({
          key,
          label: columnExportMap[key].label,
          value: columnExportMap[key].value
        }));

      const header = ['ID', ...exportColumns.map(col => col.label)];
      const rows = dataToExport.map(r => [
        r.id || '',
        ...exportColumns.map(col => col.value(r))
      ]);

      const table = `
        <table>
          <thead>
            <tr>${header.map(h => `<th>${h}</th>`).join('')}</tr>
          </thead>
          <tbody>
            ${rows.map(cols => `<tr>${cols.map(c => `<td>${c != null ? String(c) : ''}</td>`).join('')}</tr>`).join('')}
          </tbody>
        </table>
      `;

      win.document.write(`<!doctype html><html><head><meta charset="utf-8">${style}<title>Invoices Export</title></head><body><h2>Invoices Export</h2>${table}</body></html>`);
      win.document.close();
      win.focus();
      win.print();

      setAlert({
        type: 'success',
        message: selectedRows && selectedRows.length > 0 
          ? `${selectedRows.length} selected invoice(s) exported to PDF successfully!`
          : hasActiveFilters()
          ? `${dataToExport.length} filtered invoice(s) exported to PDF successfully!`
          : 'All invoices exported to PDF successfully!'
      });
    } catch (e) {
      console.error('Export PDF failed:', e);
      setAlert({
        type: 'danger',
        message: 'Failed to export invoices to PDF. Please try again.'
      });
    }
  };

  // Handle success submit from form
  const handleSuccessSubmit = () => {
    fetchInvoices(); // Refresh the list after create/update
    fetchStats(); // Refresh stats
  };

  // Handle alert dismissal
  const handleAlertClose = () => {
    setAlert(null);
  };

  // Auto-dismiss success alerts after 5 seconds
  useEffect(() => {
    if (alert && alert.type === 'success') {
      const timer = setTimeout(() => {
        setAlert(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [alert]);

  return (
    <div className="container-xl">
      {alert && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={handleAlertClose}
        />
      )}
      <div className="row g-2 align-items-center">
        <div className="col">
          {/* <h3 className="page-subtitle m-0">Overview</h3> */}
          <h2 className="page-title">Dashboard Invoices</h2>
        </div>
        <div className="col-auto ms-auto d-print-none">
          <div className="btn-list d-flex flex-wrap gap-2">
            {canInvoice('create') && (
              <button className="btn btn-primary" onClick={handleAddNew}>
                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-plus" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M12 5l0 14"></path>
                  <path d="M5 12l14 0"></path>
                </svg>
                New Invoice
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container-xl">
          <div className="col">
            <div className="card">
              <div className="card-header">
                <ul className="nav nav-tabs card-header-tabs" data-bs-toggle="tabs" role="tablist">
                  {/* <li className="nav-item-tab" role="presentation">
                    <a href="#tabs-overview" className="nav-link active" data-bs-toggle="tab" aria-selected="true" role="tab">Overview</a>
                  </li> */}
                  <li className="nav-item-tab" role="presentation">
                    <a href="#tabs-list-data" className="nav-link active" data-bs-toggle="tab" aria-selected="true" role="tab">List Data</a>
                  </li>
                </ul>
              </div>
              <div className="card-body">
                <div className="tab-content">
                  {/* <div className="tab-pane active show" id="tabs-overview" role="tabpanel">
                    <OverviewView stats={stats} />
                  </div> */}
                  <div className="tab-pane active show" id="tabs-list-data" role="tabpanel">
                    <GenericView
                      paginationTopContent={
                        <div className="row">
                          <div className="col-12">
                            {/* Page-specific totals row */}
                            <div className="row mb-3">
                              <div className="col-md-2">
                                <div className="d-flex flex-column">
                                  <strong>Total records for this page:</strong>
                                  <span>{invoices.length}</span>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="d-flex flex-column">
                                  <strong>Sub Total(This Page):</strong>
                                  <span>{formatCurrency(
                                    invoices.reduce((sum, inv) => {
                                      // Invoice subtotals are already persisted in IDR base currency.
                                      return sum + (parseFloat(inv.subtotal) || 0);
                                    }, 0),
                                    'IDR'
                                  )}</span>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="d-flex flex-column">
                                  <strong>PPN(This Page):</strong>
                                  <span>{formatCurrency(
                                    invoices.reduce((sum, inv) => {
                                      return sum + (parseFloat(inv.ppn) || 0);
                                    }, 0),
                                    'IDR'
                                  )}</span>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="d-flex flex-column">
                                  <strong>Total Invoiced(This Page):</strong>
                                  <span>{formatCurrency(
                                    invoices.reduce((sum, inv) => {
                                      return sum + (parseFloat(inv.totalInvoiced) || 0);
                                    }, 0),
                                    'IDR'
                                  )}</span>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="d-flex flex-column">
                                  <strong>Payment Received(This Page):</strong>
                                  <span>{formatCurrency(
                                    invoices.reduce((sum, inv) => {
                                      return sum + (parseFloat(inv.paymentReceived) || 0);
                                    }, 0),
                                    'IDR'
                                  )}</span>
                                </div>
                              </div>
                            </div>
                            {/* All filtered data totals row */}
                            <div className="row">
                              <div className="col-md-2">
                                <div className="d-flex flex-column">
                                  <strong>Total Records:</strong>
                                  <span>{pagination.totalElements}</span>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="d-flex flex-column">
                                  <strong>Sub Total:</strong>
                                  <span>{formatCurrency(totalSums.subtotal, 'IDR')}</span>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="d-flex flex-column">
                                  <strong>PPN:</strong>
                                  <span>{formatCurrency(totalSums.ppn, 'IDR')}</span>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="d-flex flex-column">
                                  <strong>Total Invoiced:</strong>
                                  <span>{formatCurrency(totalSums.totalInvoiced, 'IDR')}</span>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="d-flex flex-column">
                                  <strong>Payment Received:</strong>
                                  <span>{formatCurrency(totalSums.paymentReceived, 'IDR')}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      data={invoices}
                      columns={columns}
                      onEdit={canInvoice('edit') ? handleEditInvoice : undefined}
                      onDelete={canInvoice('delete') ? handleDeleteInvoice : undefined}
                      isLoading={loading || capabilitiesLoading}
                      isEditDisabled={(row) => row?.status === 'PAID' || row?.status === 'PARTIAL'} // ✅ Allow editing FINAL status invoices, but not PAID or PARTIAL
                      isDeleteDisabled={(row) => row?.status === 'PAID' || row?.status === 'FINAL'}
                      onSortChange={handleSortChange}
                      customRowActions={(row) => {
                        // Add finalize button if invoice is not final/paid and user has can_finalize permission
                        if (row?.status !== 'FINAL' && row?.status !== 'PAID' && canInvoice('can_finalize')) {
                          return (
                            <a
                              href="#"
                              title="Finalize Invoice"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleFinalizeInvoice(row);
                              }}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-check" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="green" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M5 12l5 5l10 -10"></path>
                              </svg>
                            </a>
                          );
                        }
                        // Show disabled finalize button for PAID/FINAL status with appropriate tooltip
                        if ((row?.status === 'FINAL' || row?.status === 'PAID') && canInvoice('can_finalize')) {
                          return (
                            <a
                              href="#"
                              title={row?.status === 'PAID' ? 'Cannot finalize: Invoice is already paid' : 'Cannot finalize: Invoice is already finalized'}
                              style={{
                                opacity: 0.4,
                                cursor: 'not-allowed',
                                pointerEvents: 'none'
                              }}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-check" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="gray" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M5 12l5 5l10 -10"></path>
                              </svg>
                            </a>
                          );
                        }
                        return null;
                      }}
                      pagination={{
                        currentPage: pagination.currentPage,
                        totalRows: pagination.totalRows,
                        rowsPerPage: pagination.rowsPerPage,
                        onPageChange: handlePageChange,
                        onRowsPerPageChange: handleRowsPerPageChange
                      }}
                      filterComponent={
                        <FilterButton offcanvasId="offcanvasInvoice" activeCount={invoiceActiveFilterCount} />
                      }
                      searchComponent={
                          <SearchInput
                            value={searchQuery}
                            onChange={handleSearchChange}
                            onKeyPress={handleSearchKeyPress}
                            placeholder="Search invoice"
                          />
                      }
                      actionButtons={
                        <ActionButtons
                          onExportExcel={canInvoice('export_data') ? handleExportExcel : undefined}
                          onExportPDF={canInvoice('export_data') ? handleExportPDF : undefined}
                        />
                      }
                      belowTopControlsContent={
                        <FilterAwarenessBar
                          title="Invoices is showing a filtered view"
                          summary={`Filtered by ${invoiceActiveFilterCount} ${invoiceActiveFilterCount === 1 ? 'criterion' : 'criteria'}`}
                          detail={invoiceFilterTags.map((tag) => tag.label).join(' · ')}
                          loading={loading || capabilitiesLoading}
                          activeCount={invoiceActiveFilterCount}
                          filterTags={invoiceFilterTags}
                          onRemoveFilter={handleInvoiceFilterTagRemove}
                          onResetFilters={handleFilterReset}
                        />
                      }
                      checkboxSelection={true}
                      selectedRows={selectedRows}
                      onSelectRow={(id, isSelected) => {
                        if (isSelected) {
                          setSelectedRows(prev => [...prev, id]);
                        } else {
                          setSelectedRows(prev => prev.filter(rowId => rowId !== id));
                        }
                      }}
                      onSelectAllRows={(itemIds) => {
                        if (Array.isArray(itemIds) && itemIds.length > 0) {
                          // Select all - merge with existing selections from other pages
                          setSelectedRows(prev => {
                            const newIds = itemIds.filter(id => !prev.includes(id));
                            return [...prev, ...newIds];
                          });
                        } else {
                          // Deselect all - remove only current page items
                          const currentPageIds = invoices.map(item => item.id);
                          setSelectedRows(prev => prev.filter(id => !currentPageIds.includes(id)));
                        }
                      }}
                      visibleColumns={visibleColumns}
                      onVisibleColumnsChange={setVisibleColumns}
                      emptyStateMessage="No invoices found"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <InvoiceForm
        formData={formData}
        formErrors={formErrors}
        handleInputChange={handleInputChange}
        handleFieldBlur={handleFieldBlur}
        handleFormSubmit={handleFormSubmit}
        isOpen={isModalOpen}
        onClose={handleModalClose}
        isEditMode={isEditMode}
        editingInvoice={editingInvoice}
        onSuccessSubmit={handleSuccessSubmit}
        isSubmitting={isSubmitting}
      />

      {/* Confirmation Modal for Delete */}
      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setItemToDelete(null);
        }}
        onConfirm={confirmDeleteInvoice}
        title="Delete Invoice"
        message={`Are you sure you want to delete this? This action cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        confirmVariant="danger"
        modalId="modal-delete-invoice"
      />

      {/* Confirmation Modal for Finalize */}
      <ConfirmationModal
        isOpen={showFinalizeModal}
        onClose={() => {
          setShowFinalizeModal(false);
          setItemToFinalize(null);
        }}
        onConfirm={confirmFinalizeInvoice}
        title="Finalize Invoice"
        message={`Are you sure you want to finalize this invoice?`}
        confirmText="Finalize"
        cancelText="Cancel"
        confirmVariant="success"
        modalId="modal-finalize-invoice"
      />

      {/* PDF Viewer Modal */}
      {showPdfModal && (
        <div className="modal modal-blur fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-fullscreen-sm-down modal-xl modal-dialog-centered" role="document">
            <div className="modal-content" style={{ height: '90vh', maxHeight: '90vh' }}>
              <div className="modal-header" style={{ flexShrink: 0 }}>
                <h5 className="modal-title">{pdfTitle}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handlePdfModalClose}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body p-0" style={{ flex: 1, overflow: 'hidden' }}>
                {pdfUrl && (
                  <iframe
                    src={pdfUrl}
                    width="100%"
                    height="100%"
                    style={{ 
                      border: 'none',
                      minHeight: 'calc(90vh - 120px)',
                      maxHeight: 'calc(90vh - 120px)'
                    }}
                    title="PDF Viewer"
                  />
                )}
              </div>
              <div className="modal-footer" style={{ flexShrink: 0 }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handlePdfModalClose}
                >
                  Close
                </button>
                {pdfUrl && (
                  <a
                    href={pdfUrl}
                    download={`${pdfTitle}.pdf`}
                    className="btn btn-primary"
                  >
                    Download PDF
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {showPdfModal && <div className="modal-backdrop fade show"></div>}

      {/* Filter Offcanvas */}
      <AdvancedFilterPanel
        offcanvasId="offcanvasInvoice"
        title="Filter"
        filterData={filterData}
        onChange={handleFilterChange}
        onApply={handleFilterApply}
        onReset={handleFilterReset}
        showPeriod
        filterFields={[
          { type: 'dateRange', label: 'Bill Date', fromKey: 'billDateFrom', toKey: 'billDateTo' },
          { type: 'dateRange', label: 'Due Date',  fromKey: 'dueDateFrom',  toKey: 'dueDateTo'  },
          { key: 'department',    label: 'Department',     type: 'select',      options: filterOptions.departments },
          { key: 'assignedUser',  label: 'Assigned To',  type: 'select',      options: cascadedInvoiceAssignedUsers },
          { key: 'createdBy',     label: 'Created By',     type: 'select',      options: cascadedInvoiceCreatedByUsers },
          { key: 'company',       label: 'Company',        type: 'select',      options: filterOptions.clients },
          { key: 'updatedBy',     label: 'Updated By',     type: 'select',      options: filterOptions.updatedByUsers },
          { key: 'invoiceTo',     label: 'Invoice To',     type: 'text',        placeholder: 'Search invoice recipient' },
          { key: 'invoiceIssued', label: 'Term of Payments', type: 'select',      options: [
              { value: '', label: 'All' },
              { value: 'before', label: 'Before' },
              { value: 'after',  label: 'After'  },
            ] },
          { key: 'status',        label: 'Status',         type: 'multiselect', options: filterOptions.statuses },
          { key: 'service',       label: 'Service',        type: 'select',      options: filterOptions.services },
        ]}
      />
    </div>
  );
};

export default Invoice; 
